export const ROUTES = {
  PRODUCTS_BASE: "/products",
  PRODUCTS_LIST: "/products/list",
  PRODUCTS_DETAILS: "/products/details",
};
